$bog_bzrl_app_footer $mol_view
	sub /
		<= Top $mol_view
			sub /
				<= Contact $mol_view
					sub /
						<= Email $mol_link
							uri \mailto:example@example.com
							sub /
								\example@example.com
						<= Email_hint $mol_paragraph
							title @ \Feedback email
						<= Phone $mol_link
							uri \tel:+79876543211
							sub /
								\+7 987 654 32 11
						<= Phone_hint $mol_paragraph
							title @ \For rental inquiries
				<= Social $mol_view
					sub /
						<= Ig $mol_link
							uri \https://instagram.com
							sub / <= Ig_icon $mol_image
								uri \bog/bzrl/assets/HomeRent-Design-System-Frame-82.png
						<= Vk $mol_link
							uri \https://vk.com
							sub / <= Vk_icon $mol_image
								uri \bog/bzrl/assets/HomeRent-Design-System-Frame-83.png
						<= Tg $mol_link
							uri \https://t.me
							sub / <= Tg_icon $mol_image
								uri \bog/bzrl/assets/HomeRent-Design-System-Frame-84.png
		<= Nav $mol_view
			sub /
				<= Nav_main $mol_view
					sub /
						<= nav_main_title @ \Navigation
						<= Nav_main_links $mol_list
							rows /
								<= nav_home $mol_link
									uri <= nav_home_link \
									title @ \Home
								<= nav_profile $mol_link
									uri <= nav_profile_link \
									title @ \Profile
								<= nav_all $mol_link
									uri <= nav_all_link \
									title @ \All apartments
								<= nav_rent $mol_link
									uri <= nav_rent_link \
									title @ \Rent out an apartment
								<= nav_get $mol_link
									uri <= nav_get_link \
									title @ \Rent an apartment
				<= Nav_catalog $mol_view
					sub /
						<= nav_catalog_title @ \Catalog
						<= Nav_catalog_links $mol_list
							rows /
								<= nav_districts $mol_link
									uri <= nav_districts_link \
									title @ \Districts
								<= nav_new $mol_link
									uri <= nav_new_link \
									title @ \New
								<= nav_furnished $mol_link
									uri <= nav_furnished_link \
									title @ \Furnished
								<= nav_pets $mol_link
									uri <= nav_pets_link \
									title @ \Pets allowed
								<= nav_studio $mol_link
									uri <= nav_studio_link \
									title @ \Studios
				<= Nav_docs $mol_view
					sub /
						<= nav_docs_title @ \Documents
						<= Nav_docs_links $mol_list
							rows /
								<= nav_privacy $mol_link
									uri <= nav_privacy_link \
									title @ \Privacy policy
								<= nav_terms $mol_link
									uri <= nav_terms_link \
									title @ \User agreement / offer
								<= nav_consent $mol_link
									uri <= nav_consent_link \
									title @ \Consent to personal data processing
								<= nav_cookies $mol_link
									uri <= nav_cookies_link \
									title @ \Cookies policy
		<= Bottom $mol_view
			sub /
				<= Copyright $mol_paragraph
					title <= copyright \© HomeRent, 2024
				<= Address $mol_paragraph
					title @ \123456, Moscow, Tverskaya St., 10, office 125
